<h2 mat-dialog-title class="perse-dialog-title">Filter</h2>
<mat-dialog-content>
  <div class="filter-container">
    <div class="filter-operator">
      <div class="operator-section">
        <span class="operator-label">Operator between conditions:</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="operator-field">
          <mat-select [(ngModel)]="filterConfig.operator">
            <mat-option value="AND">AND</mat-option>
            <mat-option value="OR">OR</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button mat-button color="warn" (click)="clearFilter()">
        <mat-icon>clear</mat-icon> Clear All
      </button>
    </div>
    <div class="conditions">
      <ng-container *ngFor="let condition of filterConfig.conditions; let conditionIndex = index">
        <!-- Display operator chip between conditions -->
        <div *ngIf="conditionIndex > 0" class="operator-chip">
          {{filterConfig.operator}}
        </div>
        <div class="condition-row">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Column</mat-label>
            <mat-select [(ngModel)]="condition.columnName" 
                      (selectionChange)="onColumnChange(condition, $event.value)">
              <mat-option *ngFor="let column of columns" [value]="column.name">
                {{column.displayName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="condition.columnName" subscriptSizing="dynamic">
            <mat-label>Operator</mat-label>
            <mat-select [(ngModel)]="condition.operator" (selectionChange)="onOperatorChange(condition)">
              <mat-option *ngFor="let op of getOperators(condition.columnType)" [value]="op">
                {{formatOperator(op)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <!-- Value field based on column type -->
          <ng-container *ngIf="condition.columnName && !(condition.columnType === ColumnType.Boolean && (condition.operator === 'isTrue' || condition.operator === 'isFalse'))">
            
            <!-- String and Number inputs -->
            <mat-form-field subscriptSizing="dynamic" *ngIf="condition.columnType === ColumnType.String || condition.columnType === ColumnType.Number">
              <mat-label>Value</mat-label>
              <input matInput [(ngModel)]="condition.value" 
                   [type]="condition.columnType === ColumnType.Number ? 'number' : 'text'">
            </mat-form-field>
            
            <!-- Boolean select -->
            <mat-form-field subscriptSizing="dynamic" *ngIf="condition.columnType === ColumnType.Boolean">
              <mat-label>Value</mat-label>
              <mat-select [(ngModel)]="condition.value">
                <mat-option [value]="true">True</mat-option>
                <mat-option [value]="false">False</mat-option>
              </mat-select>
            </mat-form-field>
            
            <!-- Date input -->
            <mat-form-field subscriptSizing="dynamic" *ngIf="condition.columnType === ColumnType.Date">
              <mat-label>Value</mat-label>
              <input matInput [matDatepicker]="picker" [(ngModel)]="condition.value">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            
            <!-- End date for Between operator -->
            <mat-form-field subscriptSizing="dynamic" *ngIf="condition.columnType === ColumnType.Date && condition.operator === 'between'">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endPicker" [(ngModel)]="condition.endValue">
              <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </ng-container>
          
          <button mat-icon-button color="warn" (click)="removeCondition(conditionIndex)">
            <mat-icon>remove_circle</mat-icon>
          </button>
        </div>
      </ng-container>
      <button mat-button color="primary" (click)="addCondition()">
        <mat-icon>add</mat-icon> Add Condition
      </button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!hasActiveFilters()" (click)="applyFilter()">Apply Filter</button>
</mat-dialog-actions>
